import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background-color: rgba(252, 252, 252, 0.7);
`;

export const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: ${props => (props.show ? "flex" : "none")};
  justify-content: center;
  padding: 10px 0;

  .overlay {
    background-color: rgba(252, 252, 252, 0.7);
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 9998;
  }
`;

export const ModalContainer = styled.div`
  position: relative;
  z-index: 99999;
  min-width: 448px;
  width: 448px;
  //min-height: 314px; todo check (feature denial modal needs comment)
  box-shadow: 0 2px 14px 0 #cccccc;
  background-color: ${Variables.colors.complementary};
  height: fit-content;
  margin: auto;
  .image {
    img {
      min-height: 280px;
      width: 100%;
    }
  }
  .content {
    padding: 24px 24px 0 24px;
    i {
      color: ${Variables.colors.complementary_600};
      &::before {
        font-size: ${Variables.font_sizes.giant};
      }
    }
    span {
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_600};
      display: block;
      line-height: 1.58;
      margin-top: 10px;
    }
    p {
      font-size: ${Variables.font_sizes.x_medium};
      color: ${Variables.colors.complementary_900};
      //width: 312px;
      line-height: 1.6;
      margin-top: 8px;
      text-align: justify;
    }
    .bottom-left-link {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: ${Variables.font_sizes.x1_medium};
      color: ${Variables.colors.tertiary_800};
      margin: 8px 0;
      cursor: pointer;
      &:hover {
        font-weight: ${Variables.font_weight.medium};
      }
    }
  }
  .call-button {
    text-align: left;
    font-size: ${Variables.font_sizes.x1_medium};
    width: 100%;
    svg {
      margin-left: 8px;
    }
    button {
      display: inline-flex;
      align-items: center;
      padding: 4px 10px !important;
    }
  }
`;
export const FooterModal = styled.div`
  padding: 8px 8px 24px 8px;
  width: 100%;
  display: flex;
  font-size: 13px !important;
  font-weight: 500 !important;
  justify-content: space-between;
  .right {
    display: flex;
    .label {
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_700};
      padding: 8px 16px 0 0;
      width: fit-content;
      height: fit-content;
    }
  }
  .left {
    display: flex;
    flex-direction: row-reverse;
    .button {
      margin-right: 10px;
    }
  }
  .main-button {
  }
`;
